<script>
import UserAvatar from '@components/user/user-avatar.vue'
import TheProfileMenuCard from '@components/layout/the-profile-menu-card.vue'
import { mapGetters } from 'vuex'
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'TheProfileDropdown',
  components: {
    UserAvatar,
    TheProfileMenuCard,
  },
  mixins: [baseMixin],
  computed: {
    ...mapGetters({
      user: 'auth/currentUser',
      userFullName: 'auth/currentUserFullName',
      userEmail: 'auth/currentUserEmail',
      isLoggedIn: 'auth/isUserLoggedIn',
      isLoadingAuth: 'auth/isLoadingAuth',
    }),
    compTitle() {
      return `Currently logged in as ${this.userFullName}`
    },
  },
}
</script>

<template>
  <div v-if="isLoggedIn">
    <v-menu
      bottom
      close-on-click
      :close-on-content-click="false"
      :nudge-width="150"
      nudge-bottom
      offset-y
      max-width="400"
      class="custom-elevation"
    >
      <template v-slot:activator="{ on: menu }">
        <v-list
          id="menu-user-profile-dropdown-btn"
          :title="compTitle"
          class="py-0 d-xl d-lg transparent"
          height="72"
        >
          <v-list-item class="profile-dropdown__list-item" v-on="{ ...menu }">
            <v-list-item-avatar class="overflow-visible" :class="['px-0 mx-0']">
              <UserAvatar size="42" :font-size="14" :name="userFullName" />
            </v-list-item-avatar>
          </v-list-item>
        </v-list>
      </template>

      <TheProfileMenuCard id="menu-user-settings" />
    </v-menu>
  </div>
</template>

<style lang="scss" scoped>
.profile-dropdown__list-item {
  height: 72px !important;
}
</style>
